import { render } from "./BoxIndicacao.vue?vue&type=template&id=c6943c48"
import script from "./BoxIndicacao.vue?vue&type=script&lang=js"
export * from "./BoxIndicacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__